<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <AmountSelectorJlicYavnehBayit />
            <ErrorLabel field="amount" />
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation information">
            <FormRow inline>
              <DonationFrequency
                fieldType="dropdown"
                class="donation__frequency"
                :showMsg="false"
              />
              <FormCol field="Choose a city for attribution">
                <FormSelect field="applications.0.campaign">
                  <option value="">Choose Gift Designation</option>
                  <option value="Yavneh Bayit">Any City</option>
                  <option value="Yavneh Bayit - Atlanta">Atlanta, GA</option>
                  <option value="Yavneh Bayit - Boston">Boston, MA</option>
                  <option value="Yavneh Bayit - Haifa">Haifa, Israel</option>
                  <option value="Yavneh Bayit - Irvine">Irvine, CA</option>
                  <option value="	Yavneh Bayit - Jerusalem">Jerusalem, Israel</option>
                  <option value="Yavneh Bayit - Los Angeles">Los Angeles, CA</option>
                  <option value="Yavneh Bayit - Crown Heights">
                    NYC - Crown Heights
                  </option>
                  <option value="Yavneh Bayit - Downtown">NYC - Downtown</option>
                  <option value="Yavneh Bayit - UWS">NYC - Upper West Side</option>
                  <option value="Yavneh Bayit - Washington Heights">
                    NYC - Washington Heights
                  </option>
                  <option value="Yavneh Bayit - Philadelphia">Philadelphia, PA</option>
                  <option value="Yavneh Bayit - Seattle">Seattle, WA</option>
                  <option value="Yavneh Bayit - Washington">Washington, DC</option>
                  <option value="Yavneh Bayit">I’d like to sponsor a new city</option>
                </FormSelect>
              </FormCol>
            </FormRow>
            <div class="frequencyNote" v-if="form.dayOfMonth">
              Your donation will be made today and on the
              <strong>{{ monthDay }}</strong> of each following month using the payment
              method selected. You may change or cancel this amount at any time.
            </div>
            <FormRow inline>
              <FormCol field="custom.inMemoryOf">
                <FormInput type="text" />
              </FormCol>
              <FormCol field="custom.inHonorOf">
                <FormInput type="text" />
              </FormCol>
            </FormRow>
            <FormRow inline>
              <FormCol field="Designation" width="half">
                <FormSelect field="applications.0.subCampaign">
                  <option value="">Choose Gift Designation</option>
                  <option value="General Donation">Any Program</option>
                  <option value="Innovation Fund">Innovation Fund</option>
                  <option value="Shabbatonim and Networking">
                    Shabbatonim and Networking
                  </option>
                  <option value="YB Fellowship">YB Fellowship</option>
                  <option value="YB Residents">YB Residents</option>
                </FormSelect>
              </FormCol>
            </FormRow>
            <FormRow>
              <FormLabel>
                <input type="checkbox" field="custom.naming" /> I would like to be
                contacted regarding naming opportunities
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { onMounted, computed } from "vue";
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, submit } = usePaymentForm();

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    return {
      form,
      submit,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!;

        const j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return i + "st";
        }
        if (j == 2 && k != 12) {
          return i + "nd";
        }
        if (j == 3 && k != 13) {
          return i + "rd";
        }
        return i + "th";
      }),
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep .ou-donation-form {
  .control-label {
    max-width: 100%;
  }
  h2 {
    font-size: 24px;
    line-height: 1.6;
    border-bottom: 1px solid #ccc;
    color: #333333;
  }
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.frequencyNote {
  background: #f2f5f8;
  padding: 15px;
  border-radius: 4px;
  margin-top: 15px;
  line-height: 1.4;
  font-size: 13px;
  margin-bottom: 20px;
}
</style>
